module.exports = __webpack_public_path__ + "static/media/back.3fd7b812.svg";